export default {
	inserted(el) {
		const findParentWithBackground = (element) => {
			if (!element) return null;

			const computedStyle = window.getComputedStyle(element);
			const backgroundColor = computedStyle.backgroundColor;

			// Check if the background color is not transparent and not rgba(0,0,0,0)
			if (backgroundColor && backgroundColor !== 'transparent' && backgroundColor !== 'rgba(0, 0, 0, 0)') {
				return backgroundColor;
			}

			// If we've reached the body element and no background color was found,
			// return the body's background color
			if (element === document.body) {
				return backgroundColor;
			}

			return findParentWithBackground(element.parentElement);
		};

		const parentBackgroundColor = findParentWithBackground(el.parentElement);

		if (parentBackgroundColor) {
			el.style.backgroundColor = parentBackgroundColor;
		}
	},
};
